var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 40,
    viewBox: "0 0 34 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\xD0\xA0\xD0\xB5\xD0\xB6\xD0\xB8\xD0\xBC_\xD0\xB8\xD0\xB7\xD0\xBE\xD0\xBB\xD1\x8F\xD1\x86\xD0\xB8\xD0\xB8",
    clipPath: "url(#clip0_12_475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.3692 39.9997C25.4791 39.5677 24.3045 37.8183 23.1406 36.2848C21.0689 33.5634 19.275 30.6261 17.3101 27.8183C16.4986 26.652 15.7511 26.3172 14.8434 27.9587C13.1349 31.004 11.2555 33.963 9.35475 36.8896C8.36166 38.423 7.4006 40.2157 5.09407 39.8917C2.72346 39.5569 1.20713 37.9911 0.096579 36.0472C-0.159702 35.5937 0.128614 34.5677 0.502358 34.0386C3.55638 29.6325 6.67447 25.2697 9.82459 20.9284C10.6682 19.7621 10.6148 19.0278 9.61103 17.8615C6.88804 14.6865 4.3359 11.3604 1.83716 8.00187C0.256755 5.88524 0.897458 2.75349 3.01178 1.31721C5.84155 -0.615838 7.98791 -0.324261 9.91002 2.31073C12.0564 5.24809 14.1707 8.20706 16.285 11.166C17.4917 12.8615 18.0363 12.7751 19.0828 10.9284C20.6738 8.12066 22.2649 5.30209 24.0375 2.6023C26.0985 -0.529445 28.4584 -0.788624 31.3629 1.61958C31.8862 2.05155 32.356 2.53751 32.7938 3.05587C33.5947 4.00619 33.7869 4.74053 32.8152 5.97164C29.665 9.96732 26.7712 14.179 23.7492 18.2719C23.0444 19.2222 23.1299 19.9889 23.856 20.896C26.9207 24.7405 29.8786 28.6714 32.9967 32.4835C34.2034 33.963 34.4276 35.3561 33.1569 36.7276C31.6833 38.3366 30.0281 39.7729 27.3799 39.9997",
    fill: "#302E2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackCross);
export default __webpack_public_path__ + "static/media/black_cross.cd38b5a4f04ce0598baa3fe5a939f09e.svg";
export { ForwardRef as ReactComponent };